export default __webpack_public_path__ + "static/media/FlowerPetals_Final.256.c53759b0.png";